export default __webpack_public_path__ + "static/media/5.f280ee3c.jpeg";